import { wrap, createGuid } from "src/scripts/mixin";

export default (dom) => {

    // alert("test"); 

    dom.querySelectorAll(".accordian-title").forEach(item => {


        const guid = createGuid();

        item.removeAttribute("onblur");
        item.removeAttribute("onclick");
        item.classList.add("accordian__title");

        wrap(item, "button");

        const button = item.parentElement;
        // const buttonElement = item.parentElement;
        
        wrap(button, "h2");
        
        const text = button.childNodes[0].textContent;
        const headerButton = button.parentNode;
        const box = button.parentNode.parentNode.querySelector(".accordian-content");
        
        // console.log(box);
        
        // box
        box.removeAttribute("onblur");
        box.removeAttribute("onclick");
        box.classList.add("accordian__content");
        box.id = "accordian-boxcontent-" + guid;
        box.setAttribute("aria-labelledby", "accordian-boxheader-" + guid);
        box.setAttribute("data-parent", "box-" + guid);
        
        
        // button
        button.classList.add("accordian__titlebutton");
        button.innerHTML = text;
        button.setAttribute("type", "button");
        button.dataset.toggle = "collapse";
        button.dataset.target = "accordian-boxcontent-" + guid;
        button.setAttribute("aria-expanded", "false");
        button.setAttribute("aria-controls", "accordian-boxcontent" + guid);
        
        // headerbutton
        headerButton.classList.add("accordian__title");
        headerButton.id = "accordian-boxheader-" + guid
        

    });

    return dom;

}
export const accordianClickEvent = () => {
    
    document.querySelectorAll(".accordian__titlebutton").forEach(button => {
        
        
        button.addEventListener("click", me => {
        
        const box = document.getElementById(button.dataset.target);
        if(![...button.classList].includes("accordian__titlebutton-open")){
            button.classList.add("accordian__titlebutton-open");
            box.classList.add("accordian__content-open");
        }
        else {
            button.classList.remove("accordian__titlebutton-open");
            box.classList.remove("accordian__content-open");
        }
        
    }, false)
        
        
    });
    
}